<template>
	<main class="view-student">
		<h1>学生详情</h1>

		<div style="text-align: center;">
			<el-avatar :size="120" :src="model.account.avatar" />
			<br />
			<br />
			<span class="realname">{{ model.account.realname }}</span>
			<br />
			<span class="number_in_class">{{ model.number_in_class }}号</span>
		</div>

		<div style="margin-top: 20px;">
			<el-row :gutter="20">
				<el-col :span="3" class="field_label">登录名</el-col>
				<el-col :span="20" class="field_val">{{ model.account.login_name }}</el-col>
			</el-row>

			<el-row :gutter="20">
				<el-col :span="3" class="field_label">手机号</el-col>
				<el-col :span="20" class="field_val">{{ model.account.mobile }}</el-col>
			</el-row>

			<el-row :gutter="20">
				<el-col :span="3" class="field_label">学号</el-col>
				<el-col :span="20" class="field_val">{{ model.account.serial }}</el-col>
			</el-row>
		</div>

		<div v-if="canView">
			<h1 style="margin-top: 3em;">历史评估表</h1>

			<div style="display: flex; justify-content: space-between; margin-top: 2em;">
				<div>
					<el-select
						v-model="student.currentEvaluationTable"
						placeholder="选择切换学期"
						@change="onChangeEvaluationTable"
					>
						<el-option
							v-for="(item, index) in student.evaluationTables"
							:key="item.value + index"
							:label="item.label"
							:value="item.value"
						></el-option>
					</el-select>
					<template
						v-if="
							$store.state.user.userInfo.type === $api.account.types.PLATFORM_ADMIN.value ||
							$store.state.user.userInfo.type === $api.account.types.OTHER.value
						"
					>
						<el-select
							style="margin-left: 20px;"
							v-model="currentCategory"
							placeholder="选择评测类型"
							@change="onChangeSubjectTable"
						>
							<el-option v-for="item in classSubject" :key="item.id" :label="item.name" :value="item.id"></el-option>
						</el-select>
					</template>
				</div>
			</div>
			<evaluation-sheet :data="student.evaluationData" style="margin: 0;" />

			<h1 style="margin-top: 3em;">评测</h1>

			<!-- the component fetches the data inside -->
			<student-test-list style="margin-top: 2em;" :studentId="studentId" :category="currentCategoryProps" />
		</div>
	</main>
</template>
<script>
import EvaluationSheet from '../EvaluationSheet/CompEvaluationSheet'
import StudentTestList from './StudentTestList'
import ApiClient from '@midipro/js-api'

export default {
	data() {
		return {
			canView: false,
			allSemester: [],
			classSubject: [],
			model: {
				number_in_class: null,
				account: {}
			},

			student: {
				evaluationData: {},
				currentEvaluationTable: null,
				evaluationTables: []
			},

			activeTab: this.$api.test.types.PRACTICE.key,

			currentCategory: null
		}
	},
	async created() {
		this.model = await this.$api.student.show(this.$route.params.id)

		this.$emit('breadcrumbChange', [
			{
				name: '学生详情',
				to: null
			}
		])

		let userType = this.$store.state.user.userInfo.type

		switch (userType) {
			case this.$api.account.types.TEACHER.value:
				this.currentCategory = this.$store.state.user.userInfo.teacher.subject_id
				this.canView = true
				break
			case this.$api.account.types.BUREAU_ADMIN.value:
				if (this.$store.state.user.userInfo.bureau_admin.subject) {
					this.currentCategory = this.$store.state.user.userInfo.bureau_admin.subject_id
					this.canView = true
				} else {
					this.canView = false
					return
				}
				break
			case this.$api.account.types.SCHOOL_ADMIN.value:
				this.canView = false
				return
			case this.$api.account.types.PLATFORM_ADMIN.value: {
				let resSub = await this.$api.subject.list(this.model.school_id)
				this.classSubject = resSub.data

				this.canView = true

				//选中第一个
				this.currentCategory = this.classSubject[0].id

				this.setupEvaluation()
				break
			}
		}

		this.setupEvalDropdown()
	},
	methods: {
		async setupEvaluation() {
			let api = new ApiClient()
			//拿到学科列表先生成评估表
			this.classSubject.map(async el => {
				await api.user
					.getStudentLatestEvaluation(this.$route.params.id, {
						subject_id: el.id
					})
					.catch(err => {}) // real
			})
		},

		async setupEvalDropdown() {
			var { data } = await this.$api.user.listStudentEvaluations(this.$route.params.id) // real

			if (data.length <= 0) return

			const semesterText = semester => (semester === 1 ? '上学期' : '下学期')
			const createDropDownItem = ({ year, semester, subject_id }) => ({
				value: `${year}_${semester}`,
				label: `${year}学年${semesterText(semester)}`,
				subject_id: subject_id
			})
			const dropdownItems = data.map(createDropDownItem)

			this.allSemester = dropdownItems
			this.student.currentEvaluationTable = this.allSemester[0].value

			this.onChangeSubjectTable()
		},

		async onChangeEvaluationTable(selected) {
			let [year, semester] = selected.split('_')
			this.student.evaluationData = await this.$api.user.getStudentEvaluations(this.$route.params.id, year, semester, {
				subject_id: this.currentCategory
			})
		},

		async onChangeSubjectTable() {
			//根据当前学科获取指标表
			this.student.evaluationTables = this.allSemester.filter(el => {
				return el.subject_id === this.currentCategory
			})
			if (this.student.evaluationTables.length != 0) {
				this.student.currentEvaluationTable = this.student.evaluationTables[0].value
				this.onChangeEvaluationTable(this.student.currentEvaluationTable)
			} else {
				this.student.currentEvaluationTable = '无评估表'
				this.student.evaluationData = null
			}
		}
	},
	computed: {
		studentId() {
			return Number(this.$route.params.id)
		},
		currentCategoryProps() {
			let target = this.classSubject.filter(el => {
				return this.currentCategory === el.id
			})
			if (target[0]) return target[0].slug
			else return null
		}
	},
	components: {
		'evaluation-sheet': EvaluationSheet,
		'student-test-list': StudentTestList
	}
}
</script>

<style lang="scss">
.view-student {
	padding: 30px;

	.field_label {
		text-align: right;
		font-size: 16px;
	}

	.field_val {
		font-weight: lighter;
		font-size: 16px;
	}

	.realname {
		font-size: 24px;
		margin-top: 1em;
	}

	.number_in_class {
		font-weight: lighter;
	}
}
</style>
